const IDENTIFICATION_STATUSES = {
  approved: 'approved',
  expired: 'expired',
  rejected: 'rejected'
};

export default IDENTIFICATION_STATUSES;
